import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import VersionText from "../theme/components/VersionText.jsx";
import { colorsFoundation } from "../theme/tokens/colors-foundation.js";
import { typographyTokens } from "../theme/tokens/typography.js";
import { dimensions } from "../theme/index.js";
import { ConsentContext } from "../contexts/ConsentContextProvider.jsx";
import { downloadConsentDocument } from "../services/consentService.js";

const FooterWrapper = styled("footer")(({ theme }) => ({
  width: "100%",
  padding: `${dimensions.md} 0`,
  borderTop: `1px solid ${colorsFoundation.neutral[200]}`,
  backgroundColor: theme.palette.background.paper,
  marginTop: "auto",
}));

/**
 * App version and the consent documents' links, shown at the end of the
 * content column of both portals. Each link opens its PDF in a new tab.
 */
export default function Footer() {
  const { footerLinks } = useContext(ConsentContext);

  const handleLinkClick = async (versionId) => {
    const blob = await downloadConsentDocument(versionId);
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <FooterWrapper>
      <Typography
        variant="caption"
        sx={{
          color: colorsFoundation.neutral[500],
          fontFamily: typographyTokens.family.body,
          textAlign: "center",
          display: "block",
        }}
      >
        <VersionText />

        {footerLinks.length > 0 ? " | " : ""}

        {footerLinks.map((link) => (
          <Box
            key={link.version_id}
            component="span"
            onClick={() => handleLinkClick(link.version_id)}
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
              "&:hover": { color: colorsFoundation.neutral[700] },
            }}
          >
            {link.label}
          </Box>
        ))}
      </Typography>
    </FooterWrapper>
  );
}
